"use client"

import {
  Dot,
  Dots,
  HeroCounter,
  HeroIndex,
  HeroNavBar,
  PlayPauseButton,
} from "./hero.styled"

type Props = {
  total: number
  activeIndex: number
  isPlaying: boolean
  autoDelaySec: number
  showDots: boolean
  showToggle: boolean
  onToggle: () => void
  goTo: (i: number) => void
}

const pad = (n: number) => String(n).padStart(2, "0")

const PauseIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden>
    <rect x="6" y="5" width="4" height="14" rx="0.5" />
    <rect x="14" y="5" width="4" height="14" rx="0.5" />
  </svg>
)
const PlayIcon = () => (
  <svg
    width="11"
    height="11"
    viewBox="0 0 11 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_15918_133528)">
      <path
        d="M3.2085 1.83325V9.16658L9.16683 5.49992L3.2085 1.83325Z"
        stroke="#020A0D"
        stroke-width="0.825"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_15918_133528">
        <rect width="11" height="11" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

const HeroNav = ({
  total,
  activeIndex,
  isPlaying,
  autoDelaySec,
  showDots,
  showToggle,
  onToggle,
  goTo,
}: Props) => {
  if (!showDots && !showToggle) return null
  return (
    <HeroNavBar>
      <HeroIndex>
        {showToggle && (
          <PlayPauseButton
            type="button"
            $paused={!isPlaying}
            aria-pressed={!isPlaying}
            aria-label={isPlaying ? "השהה" : "נגן"}
            onClick={onToggle}
          >
            {isPlaying ? <PauseIcon /> : <PlayIcon />}
          </PlayPauseButton>
        )}
        {showDots && (
          <HeroCounter>
            <span>{pad(total)}</span> / <span>{pad(activeIndex + 1)}</span>
          </HeroCounter>
        )}
      </HeroIndex>
      {showDots && (
        <Dots role="tablist" aria-label="שקופיות">
          {Array.from({ length: total }).map((_, i) => (
            <Dot
              key={i}
              role="tab"
              aria-label={`שקופית ${i + 1}`}
              aria-selected={i === activeIndex}
              $active={i === activeIndex}
              $paused={!isPlaying}
              $duration={autoDelaySec}
              onClick={() => goTo(i)}
            />
          ))}
        </Dots>
      )}
    </HeroNavBar>
  )
}

export default HeroNav
